<template>
  <b-alert
    :class="`d-flex p-2 w-100 justify-content-center align-items-center ${alertBgColor}`"
    v-model="isVisible"
    dismissible
  >
    <slot></slot>
  </b-alert>
</template>
<script>;
export default {
  name: "statusBar",
  props: {
    alertBgColor: {
      default: "bg-danger",
      type: String,
    },
  },
  computed: {
    isVisible: {
        get () {
          return this.$store.getters["statusBar/getIsVisible"];
        },
        set (value) {
            this.$store.commit("statusBar/SET_IS_VISIBLE",value)
        }
    }
  },
};
</script>